const isExternalUrl = (url: string) => {
  const regex = /^https?:\/\//i;
  return regex.test(url);
};

export default isExternalUrl;
